import "./FollowButton.css";
import api from "./api";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useFollow } from "../context/FollowContext";

const FollowButton = ({ user }) => {
  const [loading, setLoading] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [userLoaded, setUserLoaded] = useState(false);
  const { followStates, setFollowState } = useFollow();
  const navigate = useNavigate();

  // Guard against user being undefined on first render
  const userId = user?.id;
  const isFollowing = userId ? followStates[userId] || false : false;
  const isOwnProfile = currentUserId === userId;

  // Fetch current user ID once
  useEffect(() => {
    const fetchCurrentUser = async () => {
      try {
        const res = await api.get("/profile");
        setCurrentUserId(res.data.id);
      } catch (err) {
        console.error("Failed to fetch current user", err);
      } finally {
        setUserLoaded(true);
      }
    };
    fetchCurrentUser();
  }, []);

  // Fetch follow status
  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem("token");
      if (!token) return navigate("/");

      try {
        const response = await fetch(
          `https://dev-api.curu.com.au/api/follower/${userId}/profile`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const data = await response.json();
        setFollowState(userId, data.follow);
      } catch (error) {
        console.error("Error fetching follow status:", error);
      }
    };

    if (!userId) return;
    if (!(userId in followStates)) {
      fetchProfile();
    }
  }, [userId, followStates, setFollowState, navigate]);

  const handleFollowToggle = async () => {
    if (isOwnProfile) return; // Extra guard
    const token = localStorage.getItem("token");
    if (!token) return navigate("/");

    setLoading(true);
    try {
      const newFollowState = !isFollowing;
      const response = await api.put(
        `https://dev-api.curu.com.au/api/follower/${userId}/follow`,
        { follow: newFollowState },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setFollowState(userId, response.data.follow);
    } catch (error) {
      console.error("Error toggling follow:", error);
    } finally {
      setLoading(false);
    }
  };

  // If user is not yet available, render nothing to avoid transient errors
  if (!userId) return null;

  return (
    <button
      className={`follow-btn ${isFollowing ? "following" : "follow"}`}
      onClick={handleFollowToggle}
      disabled={loading || isOwnProfile || !userLoaded}
      title={isOwnProfile ? "Unable to follow user." : undefined}
    >
      {!userLoaded && isFollowing
        ? "Following"
        : isFollowing
        ? "Following"
        : "Follow"}
    </button>
  );
};

export default FollowButton;
